export default __webpack_public_path__ + "static/media/ppnTherapist4.bf86f319.jpg";